import styled from 'styled-components'

export const ChartContainer = styled.div`
  height: 328px;
  width: 100%;
  margin: 30px 0;
`
